import { render, staticRenderFns } from "./ContactsSuccess.vue?vue&type=template&id=390356f8&scoped=true&"
import script from "./ContactsSuccess.vue?vue&type=script&lang=js&"
export * from "./ContactsSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ContactsSuccess.vue?vue&type=style&index=0&id=390356f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390356f8",
  null
  
)

export default component.exports